import { useEffect, useState } from "react";

const SingleGradeStep = ({gradeStep, editStep}) => {
    const [comments, setComments] = useState(gradeStep?.comments||"");
    const [grade, setGrade] = useState(gradeStep?.grade || 0);
//     const changeGrade = (e) => {
//         const value = e.target.value;
//         if (value === "") {
//             setGrade(0);        
// } else if (!isNaN(value) && value >= 0 && value <= gradeStep.baseGrade) {
//             setGrade(value);
//         } else {
//             alert(`Please enter a valid grade between 0 and ${gradeStep.baseGrade}`);   
//         }
//     }

     const changeGrade = (e) => {
    const value = e.target.value;
    if (value === "") {
      setGrade(0);
    } else if (!isNaN(value) && value >= 0 && value <= gradeStep.baseGrade) {
      setGrade(value);
    } else {
      alert(`Please enter a valid grade between 0 and ${gradeStep.baseGrade}`);
    }
    // עדכון אב רק באירוע
    editStep({ ...gradeStep, comments, grade: parseInt(value) || 0 });
  };
  const changeComments = (e) => {
    const value = e.target.value;
    setComments(value);
    editStep({ ...gradeStep, comments: value, grade: parseInt(grade) || 0 });
  };

    // const editStepEvent = () => {
    //         const updatedStep = {
    //             ...gradeStep,
    //             comments,
    //             grade: parseInt(grade)
    //         };
    //         editStep(updatedStep);
        
       
    // }

    // useEffect(() => {
    //     editStepEvent();
    // }, [comments, grade]);

    useEffect(() => {
    setGrade(gradeStep?.grade || 0);
    setComments(gradeStep?.comments || "");
  }, [gradeStep.grade, gradeStep.comments]);


  return (
        <div className="flex items-center  border-b border-gray-800 gap-2 p-2">

            <h3 className="text-lg font-semibold flex-1 " > {gradeStep?.title}  </h3>
            <span>%</span>
            <input type="number" min={0} max={gradeStep.baseGrade} value={grade} onChange={changeGrade} className="border p-1 w-20 mb-2" placeholder="Grade" />
            <span> מתוך</span>
            <div className="text-lg font-semibold " >{gradeStep.baseGrade}%  </div>
            <input type="text" value={comments} onChange={changeComments} className="border p-1  mb-2" placeholder="Comments" />
          
           

           
        </div>
  )
}

export default SingleGradeStep